import React from "react";
import "./contact.css"; // Assuming you add some styles
import { FaEnvelope, FaPhone, FaLinkedin, FaGithub } from "react-icons/fa"; // Icons for social media links

const Contact = () => {

    return (
        <div className="contact-container">
            <h1>Contact Me</h1>
            <hr></hr>
            <div className="contact-details">

                <p>
                    Hi, I'm <strong>Aman Kumar Patel</strong>, an <strong>Associate Software Developer</strong> at <strong>Dataman</strong>.
                    I specialize in <strong>Full Stack Web Development</strong> and have a deep passion for building
                    real-world web applications that solve meaningful problems.
                    Whether it's designing intuitive user interfaces or building robust back-end systems,
                    I'm always excited about creating impactful digital experiences.
                </p>
                <p>
                    I'm always open to new opportunities, collaborations, or project discussions.
                    Feel free to get in touch with me for a chat about technology, development, or future endeavors.
                </p>


                <div className="contact-info">
                    <h3>Get In Touch</h3>
                    <p>
                        <FaEnvelope /> Email: <a href="mailto:amanpatel3045@gmail.com">amanpatel3045@gmail.com</a>
                    </p>
                    <p>
                        <FaPhone /> Phone: 8299115168
                    </p>
                </div>

                <div className="social-links">
                    <h3>Connect With Me</h3>
                    <p>
                        <FaLinkedin /> <a href="https://www.linkedin.com/in/aman-patel-540a47169/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                    </p>
                    <p>
                        <FaGithub /> <a href="https://github.com/amanpatel3045" target="_blank" rel="noopener noreferrer">GitHub</a>
                    </p>
                </div>
            </div>

            <div className="contact-form">
                <h2>Send Me a Message</h2>
                <form>
                    <label htmlFor="name">Name:</label>
                    <input type="text" id="name" name="name" required />

                    <label htmlFor="email">Email:</label>
                    <input type="email" id="email" name="email" required />

                    <label htmlFor="message">Message:</label>
                    <textarea id="message" name="message" required></textarea>

                    <button type="submit">Send Message</button>
                </form>
            </div>
        </div>
    );
}

export default Contact;